// Canal do portal-web no backend: fluxo createOrderBeToC → origin_checkout 'B2C'
// (ref.: contracts/storefront-api.md e checkout-coverage.md). Hoje o preview usa só para log.
export const PROGRESSIVE_ORIGIN_CHECKOUT = 'B2C' as const

export type TProgressiveBenefitTarget = 'item' | 'shipping' | string
export type TProgressiveCountMode = 'aggregated' | 'isolated' | string

export type TProgressiveDiscountType = 'percent' | 'value' | string

export type TProgressiveRule = {
  id: number
  name: string
  condition_scope: string
  benefit_target: TProgressiveBenefitTarget
  trigger_type: string
  count_mode: TProgressiveCountMode
  /** Tipo do desconto de ITEM ('percent'|'value'). Presente quando a regra beneficia item ('item'|'both'). */
  discount_type?: TProgressiveDiscountType
  /** Tipo do abatimento de FRETE ('percent'|'value'). Presente quando a regra beneficia frete ('shipping'|'both'). */
  shipping_discount_type?: TProgressiveDiscountType
}

export type TProgressiveTier = {
  min_quantity: number
  discount_percent: number
  unit_final_price: number
  total_price: number
  /** Valor absoluto do desconto de ITEM quando rule.discount_type='value'. */
  value?: number
  /** Tipo do abatimento de FRETE desta faixa ('percent'|'value'). Presente quando a regra beneficia frete. */
  shipping_discount_type?: TProgressiveDiscountType
  /** Valor do abatimento de FRETE desta faixa (percentual ou absoluto, conforme shipping_discount_type). */
  shipping_value?: number
  open_ended?: boolean
}

export type TProductTiersResponse = {
  product_id: number
  unit_price?: number
  has_progressive_discount: boolean
  rule?: TProgressiveRule
  tiers: TProgressiveTier[]
}

export type TCartPreviewItem = {
  product_id: number
  quantity: number
}

export type TCartPreviewRequest = {
  origin_checkout: typeof PROGRESSIVE_ORIGIN_CHECKOUT
  items: TCartPreviewItem[]
}

export type TProgressiveApplicationItem = {
  product_id: number
  quantity: number
  discount: number
}

export type TProgressiveApplication = {
  rule_id: number
  rule_name: string
  tier: {
    min_quantity: number
    discount_percent: number
  }
  eligible_items: TProgressiveApplicationItem[]
  discount: number
}

export type TCartPreviewResponse = {
  total_progressive_discount: number
  applications: TProgressiveApplication[]
  ineligible_items: TCartPreviewItem[]
}

export type TRelatedProduct = {
  id: number
  uuid?: string
  name: string
  translated_name?: string
  price: number
  image?: string
  brand?: { id: number; name: string }
  shape?: { id: number; name: string }
}

export type TProductRelatedResponse = {
  product_id: number
  has_progressive_discount: boolean
  rule?: TProgressiveRule
  products: TRelatedProduct[]
}
